import { NextHead } from "../src/landingPage/layouts/LayoutComponents/NextHead";
import { ccpa } from "../src/landingPage/datasets/forms/ccpa";
import { meta } from "../src/landingPage/datasets/meta";
import { DataFormTemplate } from "../src/landingPage/views/Forms/templates/DataFormTemplate";
import { WorkInProgress } from "../src/platform/components/WorkInProgress/WorkInProgress";

const CcpaPage = () => {
  const notice =
    "Our Personal Information form is currently experiencing a temporary disruption due to unusually high and potentially malicious traffic.";
  return (
    <WorkInProgress enabled={false} notice={notice}>
      <NextHead
        currentPath="/personal-information-request-california"
        title={meta.ccpa.title}
        description={meta.ccpa.description}
      />
      <DataFormTemplate type="CCPA" data={ccpa} />
    </WorkInProgress>
  );
};

export const getInitialProps = () => {
  return {
    props: {
      wrapper: "MarketingWrapper",
    },
  };
};

export default CcpaPage;
